import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { filterLocationUrl } from '../../Config/config';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { TableHeaderContext } from '../../Contexts/TableHeaderContext';
import { UserContext } from '../../Contexts/UserContext';
import AcquirerDealRangeFilter from '../RefineSearchComponents/AcquirerDealRangeFilter';
import CityFilter from '../RefineSearchComponents/CityFilter';
import FundSector from '../RefineSearchComponents/FundSector';
import InvestorTypeFilter from '../RefineSearchComponents/InvestorTypeFilter';
import SubsectorFilter from '../RefineSearchComponents/SubSector';
import Constants from '../../Constants';
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

/**
 * The function `ReAdvisorRefineSearch` is a React component that renders a form for refining search
 * filters and applying them to a specific custom pathname.
 * @returns a JSX element, which represents the UI of the refine search component.
 */
function ReAdvisorRefineSearch({ customPathname, adviosrType, menu, generalPathname }) {
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    const navigate = useNavigate();

    const { setrefineSearchFilters, onErrorHandler,dbDropdown , setDbDropdown , refineSearchFilters,dropdown, MinAcquirerDealRange, MaxAcquirerDealRange, setMonthPickerValue, SwitchState,setSwitchState,
        InvestorOptions , setInvestorOptions ,
        lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,isMobile,setOpen,open} = useContext(PeFilterContext);
    const { setSelectedPage } = useContext(TableHeaderContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(32);

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    const [fundSectorOptions, setFundSectorOptions] = useState([])
    const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
    const [SubSectorOptions, setSubSectorOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])

  /**
   * The function `applyFilter` updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {
        const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
        const selectedFundSector = fundSectorOptions?.filter(option => option.isChecked);
        const selectedSubsector = SubSectorOptions?.filter(option => option.isChecked);
        const selectedCities = CityOptions?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        // console.log(selectedSubsector,'selectedSubsector');
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
                city: selectedCities,
            },
            [customPathname]: {
                ...prev[customPathname],
                fundSector: selectedFundSector,
                investorType: selectedInvestorType,
                subSector: selectedSubsector,
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
        }))
    }

 /**
  * The `resetFilter` function resets a specific filter in the `refineSearchFilters` state object by
  * setting its value to an empty object.
  */
    const resetFilter = () => {
        
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
    }


    // Submitting Refine Search Form 
 /**
  * The function `refineSearchFilter` updates search filters, resets certain values, applies filters,
  * and navigates to a new location if necessary.
  * @param event - The event parameter is an object that represents the event that triggered the
  * function. It contains information about the event, such as the type of event, the target element,
  * and any additional data associated with the event. In this case, it is used to prevent the default
  * behavior of the event, which is
  */
    const refineSearchFilter = (event) => {
        if(isMobile){
            setOpen(!open);
        }
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setSelectedPage(1);
        applyFilter();
        setSelected(0)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

   /**
    * The `onResetClick` function resets the selected page, resets the filter, and navigates to a
    * custom pathname if the current pathname is not already the custom pathname.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. In this case, it is likely a click event on a reset button.
    */
    const onResetClick = (event) => {
        event.preventDefault();
        setSelectedPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    useEffect(() => {

        /* The line of code `const cityIds = refineSearchFilters[customPathname]?.city?.map(value =>
        value.id) ?? [];` is extracting the IDs of the selected cities from the
        `refineSearchFilters` object. */
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])


    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // Helper functions to count applied filters for each section
    const getDealFiltersCount = () => {
        let count = 0;
        if (MinDealRangeOptions?.filter(option => option.isChecked).length > 0 || MaxDealRangeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (SubSectorOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getCompanyFiltersCount = () => {
        let count = 0;
        if (fundSectorOptions?.filter(option => option.isChecked).length > 0) count++;
        if (InvestorTypeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (CityOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (InvestorOptions?.filter(option => option.isChecked).length > 0) count++;
        if (TargetCompanyOptions?.filter(option => option.isChecked).length > 0) count++;
        if (lAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        if (tAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
                            {/* Left column - Section Headers - Horizontal on mobile, vertical on tablet+ */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                            </div>
                            
                            {/* Right column - Filter Content - Full width on mobile, 75% on tablet+ */}
                            <div className="col-span-full md:col-span-6 overflow-visible mt-4 md:mt-0 pb-4 md:pb-0">
                                {/* Deal Content */}
                                {activeFilterSection === 'deal' && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8">
                                        <AcquirerDealRangeFilter
                                            customPathname={generalPathname}
                                            MinDealOptions={MinDealRangeOptions}
                                            setMinDealOptions={setMinDealRangeOptions}
                                            MaxDealOptions={MaxDealRangeOptions}
                                            setMaxDealOptions={setMaxDealRangeOptions}
                                            MinDealRange={MinAcquirerDealRange}
                                            MaxDealrange={MaxAcquirerDealRange}
                                            label="Deal Range (US $M)"
                                            isPopupOpen={openFilterPopup === 'dealRange'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                        />
                                        <SubsectorFilter
                                            options={SubSectorOptions}
                                            setOptions={setSubSectorOptions}
                                            customPathname={customPathname}
                                            dataPath="re-investments"
                                        />
                                    </div>
                                )}

                                {/* Company Content */}
                                {activeFilterSection === 'company' && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8">
                                        <FundSector
                                            fundSectorOptions={fundSectorOptions}
                                            setFundSectorOptions={setFundSectorOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'fundSector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundSector' : null)}
                                            label="Type"
                                        />
                                        <InvestorTypeFilter
                                            InvestorTypeOptions={InvestorTypeOptions}
                                            setInvestorTypeOptions={setInvestorTypeOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'investorType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={generalPathname}
                                            label="City (of Target Company)"
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                        />
                                    </div>
                                )}

                                {/* Keyword Search Content */}
                                {activeFilterSection === 'keyword' && (
                                    <div className="w-full md:w-1/2 ">
                                        <div className="space-y-4">
                                            <Investor 
                                                options={InvestorOptions}
                                                setOptions={setInvestorOptions}
                                                customPathname={customPathname}
                                                label="Investor"
                                                menu={menu}
                                            />

                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={customPathname}
                                                label="Company"
                                                menu={menu}
                                            />

                                            {(customPathname.includes("/re/advisors/") || customPathname.includes("/re/transaction-advisors/")) ? (
                                                <>
                                                    {customPathname.includes("/re/advisors/") && (
                                                        <LAdvisor 
                                                            options={lAdvisorsOptions}
                                                            setOptions={setlAdvisorsOptions}
                                                            customPathname={customPathname}
                                                            label="Legal Advisors"
                                                            menu={menu}
                                                        />
                                                    )}
                                                    {customPathname.includes("/re/transaction-advisors/") && (
                                                        <TAdvisor 
                                                            options={tAdvisorsOptions}
                                                            setOptions={settAdvisorsOptions}
                                                            label="Transaction Advisors"
                                                            customPathname={customPathname}
                                                            menu={menu}
                                                        />
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <LAdvisor 
                                                        options={lAdvisorsOptions}
                                                        setOptions={setlAdvisorsOptions}
                                                        customPathname={customPathname}
                                                        label="Legal Advisors"
                                                        menu={menu}
                                                    />
                                                    <TAdvisor 
                                                        options={tAdvisorsOptions}
                                                        setOptions={settAdvisorsOptions}
                                                        label="Transaction Advisors"
                                                        customPathname={customPathname}
                                                        menu={menu}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* No section selected */}
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>

                    </main>
                </form>
            </div>
        </div>
    )
}

export default ReAdvisorRefineSearch
